function xhrRequest(url: string, options?: {
  timeout?: number,
  withCredentials?: boolean,
  returnXHR?: boolean,
}): Promise<unknown> {
  const timeout = options?.timeout || 3000;
  const withCredentials = options?.withCredentials || false;
  const returnXHR = options?.returnXHR || false;
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const timer = setTimeout(() => reject(), timeout);
    xhr.open('GET', url);
    if(withCredentials) {
      xhr.withCredentials = true;
    }
    xhr.onload = () => {
      clearTimeout(timer);
      if (returnXHR) {
        resolve(xhr);
      } else {
        resolve(xhr.response);
      }
    };
    xhr.send();
  });
}
export default xhrRequest
